module.exports = __webpack_public_path__ + "static/media/0326_IMG_LES_MURS_CHROMATIC_CH2_1039.5bcafcc3.png";